/* This file was generated automatically. Do not edit manually. */

export enum PortfolioProductOptions {
    SelectedByDefault = 'SelectedByDefault',
    BillAsPackage = 'BillAsPackage',
    OfferToCustomer = 'OfferToCustomer',
    ExcludePriceFromOffer = 'ExcludePriceFromOffer',
    OfferToEmployee = 'OfferToEmployee',
    CreateTask = 'CreateTask',
    ProRataCharging = 'ProRataCharging',
}
